import React from 'react'
import { Link } from "react-scroll";
import { navLinksdata } from "../../constants";
const Footer = () => {
  return (
    <div className="w-full py-20 h-auto border-b-[1px] dark:border-b-gray-600 gap-8">
      <div className="flex flex-col items-center">
        <h3 className="text-xl font-bold uppercase text-blue-600 dark:text-designColor tracking-wider mb-4">
          Quick Link
        </h3>
        <ul className="inline-flex flex-wrap items-center justify-center gap-6 lg:gap-10">
          {navLinksdata.map(({ _id, title, link }) => (
            <li
              className="text-lg  sm:font-semibold font-normal text-gray-400 tracking-wide cursor-pointer hover:text-blue-600 dark:hover:text-designColor"
              key={_id}
            >
              <Link
                // activeclassName="active"
                to={link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Footer